import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'lib-organisation-outgoing-invites-view',
  templateUrl: './organisation-outgoing-invites-view.component.html',
  styleUrls: ['./organisation-outgoing-invites-view.component.scss'],
})
export class OrganisationOutgoingInvitesViewComponent {}
